import React, { useMemo } from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { FrontTabletCheckbox } from '@/components/molecules/front-tablet/input/checkbox'
import { SearchReservationRoomType } from '@/models/reservation'
import { RoomOptionDisplayType } from '@/models/self-checkin/setting'
import { createSelfCheckinResponsiveStyle } from '@/utils/front-tablet-responsive-style'

export type Props = {
  room: SearchReservationRoomType
  value: string[]
  displayType: RoomOptionDisplayType
  onClick(): void
}

export const RoomCard: React.FC<Props> = props => {
  const { t, i18n } = useTranslation()
  const lang = i18n.language
  const isSelected = useMemo(() => props.value.includes(props.room.guestRoomAssignId), [props.value, props.room])

  const formatGuestSummary = (room: SearchReservationRoomType) => {
    const words: string[] = []
    if (room.paxAdult > 0) {
      const adultKey = room.paxAdult === 1 ? 'SelfCheckIn.adult_one' : 'SelfCheckIn.adult_other'
      words.push(t(adultKey, { count: room.paxAdult }))
    }

    if (room.paxChild > 0) {
      const childKey = room.paxChild === 1 ? 'SelfCheckIn.child_one' : 'SelfCheckIn.child_other'
      words.push(t(childKey, { count: room.paxChild }))
    }

    return words.join(', ')
  }
  return (
    <div css={cardStyle} onClick={() => props.onClick()} className={`${isSelected ? '-selected' : ''}`}>
      <div className="checkbox-block">
        <FrontTabletCheckbox value={isSelected} />
      </div>
      <div className="text-block">
        <div className="text-primary">{lang === 'ja' ? props.room.typeNameJa : props.room.typeNameEn}</div>
        <div className="text-secondary">
          {props.displayType === RoomOptionDisplayType.GuestName ? formatGuestSummary(props.room) : props.room.guestName}
        </div>
      </div>
    </div>
  )
}

const cardStyle = css(
  {
    borderRadius: 10,
    boxShadow: '0 0 0 1px #cccccc',
    background: '#fff',
    padding: '16px 24px',
    display: 'flex',
    marginTop: 16,
    '.text-block': {
      display: 'flex',
      flexDirection: 'column',
      gap: 4,
    },
    '.text-primary': {
      fontSize: 24,
      fontWeight: 'bold',
      letterSpacing: '1.2px',
      color: '#272727',
      lineHeight: '33px',
      overflow: 'hidden',
      display: '-webkit-box',
      '-webkit-line-clamp': '2',
      '-webkit-box-orient': 'vertical',
      wordWrap: 'break-word',
    },
    '.text-secondary': { fontSize: 18, fontWeight: 500, letterSpacing: '0.9px', color: '#676767', lineHeight: '25px' },
    '&.-selected': {
      boxShadow: '0 0 0 2px #f2a40b',
      backgroundColor: '#fffde3',
      '.text-primary': { color: '#f2a40b' },
    },
  },
  createSelfCheckinResponsiveStyle({
    landscape13: {
      padding: '24px',
      '.text-primary': { fontSize: 28, lineHeight: '38px', letterSpacing: '1.4px' },
      '.text-secondary': { fontSize: 22, lineHeight: '30px', letterSpacing: '1.1px' },
    },
  }),
)
